import React from 'react';
import playable from 'common/playable';

const ScheduleLink = ({ clickHandler, listing, playerHref }) => {
    const name = listing.name.trim();
    return (listing.type === 'upcoming') ?
        <div>{name}</div> :
        <a href={playerHref} data-route="false" onClick={clickHandler}>{name}</a>;
};

ScheduleLink.propTypes = {
    clickHandler: React.PropTypes.func,
    listing: React.PropTypes.object,
    playerHref: React.PropTypes.string
};

export default playable(ScheduleLink);
export { ScheduleLink as BaseScheduleLink };



// WEBPACK FOOTER //
// ./app/schedule/ScheduleLink.js